import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { TextBlockPickerComponent } from './text-block-picker.component';
import { StripHtmlPipe } from '../../../vas/pipes/strip-html.pipe';

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        TextBlockPickerComponent,
        StripHtmlPipe
    ],
    exports: [
        TextBlockPickerComponent
    ]
})
export class TextBlockPickerModule {

}



// WEBPACK FOOTER //
// ./src/app/atoms/text-block-picker/text-block-picker.module.ts